import * as React from 'react';
import { style } from 'typestyle';

import { SpaceContentsRequestAction } from '~src/app/actions/spaces/RequestSpaceContentsActions';
import { ExplorerEmptyStateProps } from '~src/app/spaces/Components/ExplorerEmpyState';
import { ConnectedExplorer } from '~src/app/spaces/Explorer/ConnectedExplorer';
import { ExplorerTestIds } from '~src/app/spaces/Explorer/Explorer';
import { ServerSettingsSubspaceName } from '~src/app/state/SpaceInfo';
import { Messages } from '~src/codegen/Localize';
import { ResourceGovernanceSettingDefiniton } from '~src/contentDefinitions/ResourceGovernanceSettingDefinition';
import { SettingsSectionList } from '~src/settings/components/settings-coordinator/SettingsSectionList';
import { cssClass } from '~src/style';

import { SchedulesGovernanceLimitsSection } from './SchedulesGovernanceLimitsSection';


export const ResourceGovernanceSubspaceName: ServerSettingsSubspaceName = 'resourcesgovernance';

// Used by unit tests
export const SiteJobLimitsSectionName = 'siteJobsLimits';
export const DefaultSiteLimitsSectionName = 'defaultSiteLimits';
export const TableSectionName = 'table';

export interface ResourceGovernanceSubspaceDispatchProps {
  readonly requestSpaceContents: () => SpaceContentsRequestAction;
}

export interface ResourceGovernanceOwnProps {

}

export type ResourceGovernanceProps = ResourceGovernanceSubspaceDispatchProps & ResourceGovernanceOwnProps;

export function ResourceGovernanceSubspace(props: ResourceGovernanceProps) {

  const siteJobsLimitsSection = <>
    <div className="tb-settings-group-name" data-tb-test-id={SiteJobLimitsSectionName + '-header'}>
      {Messages.resourceGovernanceSiteJobsLimitsHeader()}
    </div>
    <div className="tb-indent" data-tb-test-id={SiteJobLimitsSectionName + '-body'}>
      {Messages.resourceGovernanceSiteJobsLimitsBody()}
      <a href="http://example.com/todo" style={{ fontWeight: 'bold' }}>
        {Messages.learnMore()}
      </a>
    </div>
  </>;
  const defaultSiteLimitsSection = <>
    <div className="tb-settings-group-name" style={{ marginTop: 12 }} data-tb-test-id={DefaultSiteLimitsSectionName + '-header'}>
      {Messages.resourceGovernanceDefaultSiteLimitsHeader()}
    </div>
    <div className="tb-indent" data-tb-test-id={DefaultSiteLimitsSectionName + '-body'}>
      {Messages.resourceGovernanceDefaultSiteLimitsBody()}
    </div>
    <SchedulesGovernanceLimitsSection />
  </>;
  const cssPrefix = 'ResourceGovernance';
  const tableStyle = cssClass(cssPrefix, 'space-subplace-area', {
    flex: 1,
    position: 'relative',
    minHeight: 250,
  });
  const tableSection = <div className={tableStyle}>
    <ConnectedExplorer
      supportedDisplayModes={ResourceGovernanceSettingDefiniton.supportedDisplayModes}
      emptyStateProps={emptyStateProps()}
      toolbarProps={{
        supportFilterPanel: false,
        toolbarVisibility: 'enabled',
        hideSelection: false,
      }}
    />
  </div>;
  const sections = [
    {
      name: SiteJobLimitsSectionName,
      component: () => siteJobsLimitsSection,
    },
    {
      name: DefaultSiteLimitsSectionName,
      component: () => defaultSiteLimitsSection,
    },
  ];

  // Our subspace is already in a flex container (hence the flex: 1)
  // but we also need to create a flex containter of our own own (hence the other flex attributes)
  const settingsFormStyle = style({
    flex: 1,
    display: 'flex',
    paddingTop: 30,
    overflow: 'auto',
    flexDirection: 'column',
  });
  const settingsSectionListFullWidthStyle = style({
    marginLeft: 85,
    marginRight: 85,
  });
  const settings = {

  };
  return (<>
    <div className={settingsFormStyle}>
      <SettingsSectionList
        sections={sections}
        settings={settings}
        formStyle={settingsSectionListFullWidthStyle}
      />
      {tableSection}
    </div>
  </>);
}


function emptyStateProps(): ExplorerEmptyStateProps {
  return {
    dataTestId: ExplorerTestIds.ExplorerNoContent,
    iconUrl: '',
    primaryMessage: Messages.contentEmptyMessage(),
    secondaryMessage: '',
  };
}
